import { accountNumberValidationRegex, emailValidationRegex, ifscValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../../app_methods";
import { get, httpDelete, post, put } from "../../services/HttpService";

export class Vendor {
  constructor(vendor = {}) {
    this.set(vendor);
  }

  static validations = {
    id: [],
    created_at: [],
    name: [
      { required: true, message: "Name is required." },
      { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
      { min: 1, message: "Must be atleast 1 characters long" },
      { max: 100, message: "Can be of maximum 100 characters" },
    ],
    email: [
      { required: true, message: "Email is required." },
      {
        pattern: emailValidationRegex(),
        message: "Please enter a valid Email ID.",
      },
      { min: 1, message: "Must be atleast 1 characters long" },
      { max: 150, message: "Can be of maximum 150 characters" },
    ],
    phone: [
      { required: true, message: "Phone number is required." },
      {
        pattern: phoneNumberValidationRegex(),
        message: "Please enter a valid phone number.",
      },
      { max: 10, message: "Can be of maximum 10 characters" },
    ],
    account_number: [
      { required: true, message: "Account number is required." },
      {
        pattern: accountNumberValidationRegex(),
        message: "Enter a valid account number.",
      },
      { min: 3, message: "Must be atleast 3 characters long" },
      { max: 20, message: "Can be of maximum 20 characters" },
    ],
    account_ifsc: [
      { required: true, message: "Account IFSC is required." },
      {
        pattern: ifscValidationRegex(),
        message: "Please enter a valid IFSC.",
      },
      { len: 11, message: "Must be exactly 11 characters long" },
    ],
    name_on_bank: [
      { required: true, message: "Name on bank is required." },
      {
        pattern: beneficiaryNameRegex(),
        message: "Please enter a valid Account Name.",
      },
      { max: 60, message: "Can be of maximum 60 characters" },
    ],
  };

  /**
   * @memberof Vendor
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(`/vendor-payouts/v1/internal/vendors/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  /**
   * @memberof VendorInvoice
   * @type API
   * @returns Promise
   */
  static create = (queryData = {}) => {
    return post(`/vendor-payouts/v1/internal/vendors/`, queryData, {}).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      })
    );
  };

  update = (queryData = {}) => {
    queryData = { ...this.get(), ...queryData };
    return put(
      `/vendor-payouts/v1/internal/vendors/${this.id}/`,
      queryData,
      {}
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  deleteBankDetail = (queryData = {}) => {
    return httpDelete(
      `/vendor-payouts/v1/internal/vendors/delete_bank_detail/${queryData.uuid}/`,
      queryData,
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  /**
   * @memberof VendorForm
   * @type API
   * @returns Promise
   */
  fetchFormAttributes = (queryData = {}, config = {}) => {
    // debugger;
    queryData = { ...this.get(), ...queryData };
    return get(
      `/vendor-payouts/v1/internal/vendor_forms/${this.id}/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  /**
   * @memberof VendorForm
   * @type API
   * @returns Promise
   */
  update_vendor_profile = (queryData = {}, config = {}) => {
    // debugger;
    queryData = { ...this.get(), ...queryData };
    return put(
      `/vendor-payouts/v1/internal/vendors/${this.id}/profile/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  /**
   * @memberof Vendor
   * @type Setter Method
   * @takes Vendor Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof Vendor
   * @type Getter Method
   * @returns Vendor
   */
  get = () => {
    return {
      id: this.uuid,
      vendor_id: this.uuid,
      name: this.name,
      email: this.email,
      phone: this.phone,
      name_on_bank: this.name_on_bank,
      bank_name: this.bank_name,
      account_number: this.account_number,
      account_ifsc: this.account_ifsc,
      bank_branch: this.bank_branch,
      state: this.state,
      business_name: this.business_name,
      nature_of_business: this.nature_of_business,
      business_address: this.business_address,
      gstin: this.gstin,
    };
  };
}
